import HeroImage from './HeroImage'

export default HeroImage
// eslint-disable-next-line import/export
export * from './HeroImage'
